import * as React from 'react'
import SanityBlock from 'components/common/SanityBlock'
import Img from 'components/common/Img'

export default function CardList({ _rawIntro, items }) {
	return (
		<section className="ctnr padding space-y-8 md:pr-0">
			<header className="max-w-lg">
				<SanityBlock className="space-y-3" body={_rawIntro} />
			</header>

			<div className="grid grid-cols-[repeat(auto-fit,minmax(300px,1fr))] gap-8">
				{items.map((card) => (
					<article className="space-y-3" key={card._key}>
						<figure>
							<Img image={card.image} />
						</figure>

						<SanityBlock className="space-y-2" body={card._rawContent} />
					</article>
				))}
			</div>
		</section>
	)
}
